import React from 'react';
import Layout from '../../Components/Templates/Layout';
import SpaceImage from '../../Assets/Images/nasa-space.jpg';
import { Box, Center, Flex, Heading, Image, Text } from '@chakra-ui/react';

const Summary = () => {
    return (
        <Layout topBarMaxWidth={ 1400 }>
            <Flex flexDirection='column' flex='1'>
                <Flex flexDirection='row'>
                    <Flex 
                        flex='1' 
                        backgroundImage={ SpaceImage }
                        height='300px'
                        backgroundPosition='center'
                        backgroundSize='cover'
                    />
                </Flex>
                <Flex>
                    <Center display='flex' flex='1'>
                        <Flex 
                            flex='1' 
                            maxWidth='1400px' 
                            flexDirection='column'
                            padding='10px'
                        >
                            <Center>
                                <Heading 
                                    color='brand.orange'
                                    marginTop='20px'
                                    marginBottom='20px'
                                >
                                    SUMMARY
                                </Heading>
                            </Center>
                            <Flex marginBottom='40px'>
                                <Text>
                                    Precision engineers specialising in machining complex prismatic components and
                                    sub-assemblies to customer specifications using advanced machining technologies
                                    such as multi-axis milling, multi-axis turning and electrical discharge machining
                                    (EDM).
                                </Text>
                            </Flex>
                        </Flex>
                    </Center>
                </Flex>
            </Flex>
        </Layout>
    );
};

export default Summary;